import React from 'react';
import API from '../../../services/api.jsx'
import Loader from '../../layout/loader.jsx'
import Table from '../../layout/table.jsx'
import Helpers from '../../../services/helpers.jsx'
import { toast } from 'react-toastify'
import { debounce } from 'lodash'

class DeviceList extends React.Component {
	constructor(props) {
		super(props)
		let that = this

    const columns = [
      {
        label: "Device name",
        key: "name",
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: "SKU",
        key: "sku",
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: "Type",
        key: "type",
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
        view: function (field) {
          switch (field) {
            case "vox":
              return <div>VOX tablet</div>;
            case "other":
              return <div>Other</div>;
            default:
              return <div>{field}</div>;
          }
        },
      },
      {
        label: "Status",
        key: "lastPing",
        view: function (field) {
          if (!field) return <div className="red">offline</div>;

          let timestamp = +new Date(field);
          let now = +new Date();
          return now - timestamp > 60 * 60 * 1000 ? (
            <div className="red">offline</div>
          ) : (
            <div className="green">online</div>
          );
        },
      },
      {
        label: "Storage left",
        key: "storage",
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
				view: function(field){
					if (!field) return "-";
					return (
            <div className={Helpers.lessThan1GB(field.externalAvailable) ? "red" : ""}>
              <div>
                {Helpers.formatBytes(field.externalAvailable)}
              </div>
              <div style={{whiteSpace: "nowrap"}}>
                {"/" + Helpers.formatBytes(field.externalTotal)}
              </div>
            </div>
          )
				}
      },
      {
        label: "Playing",
        key: "playing",
      },
      {
        label: "Timezone",
        key: "timezone",
      },
      {
        label: "Software version",
        key: "softwareVersion",
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: "Download status",
        key: "downloadStatus",
        view: function (field) {
          if (!field) return "-";
          else if (field.downloaded === field.total)
            return (
              <div className="progress green">
                <i className="icon-done"></i> Downloaded
              </div>
            );
          else
            return (
              <div className="progress orange">
                <i className="icon-downloading"></i>{" "}
                {Math.round((field.downloaded / field.total) * 100)}% (
                {field.downloaded}/{field.total} tracks)
              </div>
            );
        },
      },
    ];
    if (Helpers.checkPermissions("devices:delete")) {
      columns.push({
        action: "delete",
        onClick: (id, key) => {
          var r = window.confirm(
            "Are you sure you want to delete this device?"
          );
          if (r === false) return;

          this.setState({ loading: true });
          API.delete("devices", id)
            .then(() => {
              toast.success("Device was successfully deleted");
              this.loadEntities();
            })
            .catch(() => {
              // toast.error("An unexpected error has occurred");
              this.setState({ loading: false });
            });
        },
      });
    }

    const actions = [];
    if (Helpers.checkPermissions('devices:edit')) {
      actions.push({
        classList: 'blue add',
        label: 'New device',
        onClick: () =>
          this.props.history.push(
            '/clients/' + this.props.match.params.clientId + '/devices/new'
          ),
      });
    }

		this.state = {
			loading: true,
			filters: {
				client: this.props.match.params.clientId,
			},
      postFilters: {},
			sort: ['createdAt', 'DESC'],
			devices: {
				columns,
				entities: [],
				filters: [],
				actions,
				selectedItems: [],
				multiSelect: false,
				onRowClick: function(entity) {
          if (
            Helpers.checkPermissions(
              ["devices:details", "devices:edit"],
              true
            )
          ) {
            that.props.history.push('/clients/' + props.match.params.clientId + '/devices/' + entity.id)
          }
				}
			}
		}
	}

	componentDidMount() {
		this.loadEntities()
	}

	onSort(key){
		const newSort = this.state?.sort?.[0] === key ? 
		this.state?.sort?.[1] === "ASC" ? [key, 'DESC'] : [key, 'ASC'] 
		: [key, 'ASC'];
		this.setState({
			sort: newSort
		}, () => {
			this.loadEntities()
		})
	}

  buildPostFilter = (key, filter) => {
		return (entity) => {
			if (entity?.[key]) return filter(entity?.[key]);
			else return false
		}
	}

	loadEntities() {
		API.getDevices(this.state.filters, this.state.sort)
			.then(entities => {
			  let postEntities = [...(entities?.data || [])];
        if (this.state.postFilters && Object.entries(this.state.postFilters)?.length > 0){
          Object.keys(this.state?.postFilters)?.forEach(key => {
            if (typeof this.state.postFilters[key]?.filter === 'function'){
              postEntities = postEntities?.filter(this.state.postFilters[key].filter)
            }
          })
        }

				const filters = [
          {
            label: 'Status',
            placeholder: 'Status',
            type: 'select',
            isClearable: true,
            entities: [
              { name: 'Online', id: 'online' },
              { name: 'Offline', id: 'offline' }
            ],
            onChange: value => {
              if (this.state?.postFilters?.['lastPing']?.value?.id !== value?.id){
                const filter = value ? this.buildPostFilter("lastPing", (val) => {
                  let timestamp = + new Date(val);
                  let now = + new Date();
                  return now - timestamp > 60 * 60 * 1000 ? (value?.id === 'offline' ? true : false) : (value?.id === 'offline' ? false : true )
                }): null

                let newFilters = this.state.devices.filters;
                newFilters[0] = {
                  ...this.state.devices.filters[0],
                  value: value
                }

                this.setState({
                  devices: {
                    ...this.state.devices,
                    filters: newFilters,
                  },
                  postFilters: {
                    "lastPing": {
                      value: value,
                      filter: filter
                    }
                  }
                }, () => this.loadEntities())
              }
            }
          }
        ];
				if (entities?.filters?.availableFilters) {
      		const filtersNames = ["name", "softwareVersion"];
					entities.filters.availableFilters = entities.filters.availableFilters.filter((filter) => 
						filtersNames.includes(filter.name)
					);
					Helpers.handleFilters(this, filters, entities);
				}

				this.setState({
					...this.state,
					loading: false,
					devices: {
						...this.state.devices,
						filters,
						entities: postEntities
					}
				})
			})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Table settings={this.state.devices} sort={this.state.sort}/>
			</>
	}
}

export default DeviceList;
